import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PublicPersonalDataRequestModel } from '../models/public-personal-data-request.model';
import { EmailVerificationModel } from '../models/email-verification.model';
import { environment } from '@environment';

@Injectable()
export class PersonalDataRequestService {
    constructor(private httpClient: HttpClient) {}
    // to get request by token
    getRequest(): Observable<PublicPersonalDataRequestModel> {
        return this.httpClient.get<PublicPersonalDataRequestModel>(environment.apiInboxUrl + 'PersonalDataRequest/');
    }

    // to start processing
    processRequest(request: PublicPersonalDataRequestModel): Observable<PublicPersonalDataRequestModel> {
        return this.httpClient.patch<PublicPersonalDataRequestModel>(
            environment.apiInboxUrl + 'PersonalDataRequest/',
            request,
        );
    }

    // to add/update contact address and send verification email
    addContactAddress(modelWithEmail: EmailVerificationModel): Observable<EmailVerificationModel> {
        return this.httpClient.post<EmailVerificationModel>(
            environment.apiInboxUrl + 'PersonalDataRequest/ContactAddress/',
            modelWithEmail,
        );
    }

    // to confirm contact email
    confirmContactAddress(confirmationCode: number): Observable<EmailVerificationModel> {
        return this.httpClient.post<EmailVerificationModel>(
            environment.apiInboxUrl + 'PersonalDataRequest/ContactAddress/ConfirmationCode/',
            confirmationCode,
        );
    }

    // to add/update email address into request and send verification email
    addEmail(modelWithEmail: EmailVerificationModel): Observable<EmailVerificationModel> {
        return this.httpClient.post<EmailVerificationModel>(
            environment.apiInboxUrl + 'PersonalDataRequest/AuthUserInfo/Emails/',
            modelWithEmail,
        );
    }

    // to confirm contact email
    confirmEmail(email: string, confirmationCode: number): Observable<EmailVerificationModel> {
        return this.httpClient.post<EmailVerificationModel>(
            environment.apiInboxUrl +
                'PersonalDataRequest/AuthUserInfo/Emails/?email=' +
                encodeURIComponent(email) +
                '&confirmationCode=' +
                confirmationCode,
            {},
        );
    }

    // to confirm contact email
    removeEmail(email: string): Observable<void> {
        return this.httpClient.delete<void>(
            environment.apiInboxUrl + 'PersonalDataRequest/AuthUserInfo/Emails/?email=' + encodeURIComponent(email),
        );
    }
}
